module.exports = __webpack_public_path__ + "img/display5.dde38fd8.jpg";